import React from 'react';
import { Box } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';


import Main from 'views/layouts/Main/Main'; // Ensure this is the correct import path for your Main component
import SimContainer from 'components/SimContainer';
import SimLeaderQuote from 'components/SimLeaderQuote';

import {
	ServiceBanner,
	FeaturesEssentials,
	SliderALLEssentialsServices,
	FeaturesCares,
	SliderALLCaresServices,
	FeaturesParentEd,
	SliderALLParentEdServices
} from './components';
import SimPolygon from 'components/svg/shapes/SimPolygon';

const Services = () => {
	const theme = useTheme();

	return (
		<Main backgroundColor={theme.palette.background.default}>
			<Box
				position={'relative'}
				sx={{
					backgroundColor:
						theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.primary.main
				}}>
				<Box paddingX={{ xs: 3, sm: 4, lg: 14 }}>
					<ServiceBanner />
				</Box>

				<Box top={'-50px'}>
					<SimPolygon Inverted />
				</Box>
			</Box>

			<Box paddingBottom={{ lg: 2 }} id='ANCHOR_Services_Essentials'>
				<Box
					sx={{
						position: 'relative',
						'&::after': {
							position: 'absolute',
							content: '""',
							width: '20%',
							zIndex: 1,
							top: 0,
							left: 0,
							height: '100%',
							backgroundSize: '17px 18px',
							backgroundImage: `radial-gradient(${alpha(
								theme.palette.primary.dark,
								0.4
							)} 20%, transparent 20%)`,
							opacity: 0.4
						}
					}}
					>
					<Box position={'relative'} zIndex={2}>
						<SimContainer>
							<FeaturesEssentials />
						</SimContainer>
					</Box>
				</Box>
			</Box>

			<Box>
				<SimContainer>
					<SliderALLEssentialsServices />
				</SimContainer>
			</Box>

			<Box bgcolor={'secondary.main'} marginTop={{ xs: '20vw', sm: '20vw', md: '5vw' }}>
				<SimContainer>
					<SimLeaderQuote />
				</SimContainer>
			</Box>

			<Box>
				<Box backgroundColor={theme.palette.background.default} id='ANCHOR_Services_ParentEd'>
					<Box>
						<FeaturesParentEd />
					</Box>

					<SimContainer backgroundColor={'transparent'}>
						<SliderALLParentEdServices />
						<br />
					</SimContainer>
				</Box>
			</Box>

			<Box>
				<Box backgroundColor={theme.palette.background.default} id='ANCHOR_Services_Cares'>
					<Box>
						<FeaturesCares />
					</Box>

					<SimContainer backgroundColor={'transparent'}>
						<SliderALLCaresServices />
						<br />
					</SimContainer>
				</Box>
			</Box>
		</Main>
	);
};

export default Services;
